/**
 * Created by gaowy on 2017/5/8.
 */

;
(function($) {
    'use strict'
    var ModuleName = 'nvb_gptb';
    var Module = function(ele, options) {
        this.elem = $(ele);
        this.df = document.createDocumentFragment();
        this.opts = options;

    };
    Module.DEFAULTS = {
        flag: false,
        anchors: [],
        mobileShow: '',
        dropOffset: 0,
        position: {
            start: null,         // scroll到什么时候开始fixed
            end: false,         // scroll到什么时候结束fixed，必须大于start，如果是false，就代表沒有結束fixed scroll點
            top: 0              // 当fixed时的top位置
        },
        time:13,//运动时间
        haveSubmitBtn: false, //是否需要submit按鈕
        haveSearchBtn:false,//是否需要搜索按钮 add by gwy at 2017/09/05
        listContinerClass: "",
        whenFixed:function(){console.log('whenFixed')},
        whenUnFixed:function(){$('.nvb_gptb').addClass('d-no');console.log('whenUnFixed')},
        whenClickSubmit:function($this) { console.log("whenClickSubmit") },
        placeName:'',//默認地點名 add by gwy at 2017/09/05
        whenClickSearch:function(){ console.log("whenClickSearch")}//搜索按鈕回調函數 add by gwy at 2017/09/05
    };
    //设置是否调用callback开关
    Module.prototype.init = function() {
        this.opts.flag = $(this.elem).hasClass('d-no');
    }
    //利用参数中anchors的moveto来计算要滚动的距离
    function scrollTop(obj) {
        var top;
        //如果是object则说明是dom元素
        if(obj.length === 0) return;
        if ($.type(obj) == 'object') {
            top = $(obj).offset().top;
        } else {
            top = parseInt(obj);
        }
        top = top == 'null' || top == 'undefined' || isNaN(top) ? $(document).scrollTop() : top;

        return top;
    }
    //创建导航栏
    Module.prototype.createEle = function() {
        //清空容器
        this.elem.html('');
        var anchors = this.opts.anchors;
        var mobileShow = this.opts.mobileShow;
        var PCsmallHide = this.opts.PCsmallHide;
        var listContainerClass = this.opts.listContainerClass;
        var div = $("<div class='nav-container'><ul class='li-list " + listContainerClass + "'></ul></div>");



        for (var i = 0; i < anchors.length; i++) {
            var $a = $('<a href="javascript:void(0)"></a>').html(anchors[i].name);
            var li = '<li class='+ ( mobileShow.indexOf(anchors[i].name) < 0 ? '' : ' m-show' ) + ( !!PCsmallHide && PCsmallHide.indexOf(anchors[i].name) >= 0 ? 'PCsmallHide' : '' ) +'></li>';
            var $li = $(li).append($a).data('moveto', anchors[i].moveto);
            if(!!anchors[i].ul && anchors[i].ul.length > 0){
                $(li).append('<div class="secMenu"><ul class="container"></ul></div>');
                for(var j = 0; j < anchors[i].ul.length; j++){
                    $(li).find('ul').append('<li></li>').find('li').eq(j).append('<a href="javascript:void(0)"></a>').find('a').html(anchors[i].ul[j].name).closest('li').data('moveto', anchors[i].ul[j].moveto);
                }
            }
            $(div).find('.li-list').append($li);
        }
        if (this.opts.haveSubmitBtn) {
            $(div).find('.li-list li').last().addClass('submitbtn'); 
            if( anchors[anchors.length-1].attr ){
                $(div).find('.li-list li').last().children('a').attr(anchors[anchors.length-1].attr);
            }
        }
        //add by gwy at 2017/09/05
        if (this.opts.haveSearchBtn) {
            var str='<li class="placeSearch"><div class="search-content"><span class="ic-ln toolmapf"></span><span class="placeName">'+this.opts.placeName+'</span></div></li>'
            $(div).find('.li-list').prepend(str);
        }

        $(this.elem).append(div);
    };
    //添加点击跳转到锚点
    Module.prototype.bindClick = function() {

        var that = this;
        var lis=this.elem.find('.li-list li');
        lis.on('click',function(e){
            var $this = $(this);
            var proxy=this;
            var moveto=scrollTop( $( $(this).data('moveto') ) );
            if ($(this).hasClass('submitbtn'))
              { that.opts.whenClickSubmit($this) }
            //add by gwy at 2017/09/05
            else if($(this).hasClass('placeSearch'))
              { that.opts.whenClickSearch($this) }
            else{
                $('html,body').stop().animate({scrollTop:moveto-that.opts.dropOffset},that.opts.time,function(){
                    $(proxy).addClass('active').siblings().removeClass('active');
                })
            }
        });
    };
    //添加document滚动事件
    Module.prototype.scroll=function(){
        var that=this;

        $(window).on('scroll',function(e){
            e.preventDefault();
            var position=that.opts.position;
            var lis=that.elem.find('.li-list li').not('.placeSearch').not('.submitbtn');//過濾首尾li add by gwy at 2017/09/05
            var scrolltop=$(document).scrollTop();

            ////导航栏添加红色标记
            for (var i = 0; i < lis.length; i++) {
                var item = lis.eq(i)
                var moveto = scrollTop($( item.data('moveto') )) - that.opts.dropOffset -10;
                if (scrolltop >= moveto) {
                    lis.removeClass('active');
                    item.addClass('active');
                }
            }
            //end为false，导航栏永久显示
            if (position.end == false) {
                if (scrolltop >= position.start) {
                    $(that.elem).find('.nav-container').css({ position: 'fixed', top: position.top, left: 0, display: 'block' })
                    if (that.opts.flag) {
                        that.opts.whenFixed();
                        that.opts.flag = !that.opts.flag;
                    }
                } else {
                    $(that.elem).find('.li-list li').removeClass('active')
                    $(that.elem).find('.nav-container').removeAttr('style')
                    if (!that.opts.flag) {
                        that.opts.whenUnFixed();
                        that.opts.flag = !that.opts.flag;
                    }

                }

            } else { //导航栏在范围内显示
                if (scrolltop >= position.start && scrolltop <= position.end) {

                    $(that.elem).find('.nav-container').css({ position: 'fixed', top: position.top, left: 0, display: 'block' })
                    if (that.opts.flag) {
                        that.opts.whenFixed();
                        that.opts.flag = !that.opts.flag;
                    }
                }
                //else if(scrolltop > position.end){
                //    $(that.elem).find('.nav-container').removeAttr('style')
                //    if(!that.opts.flag)
                //    {
                //        that.opts.whenUnFixed();
                //        that.opts.flag=!that.opts.flag;
                //    }
                //}
                else {
                    $(that.elem).find('.li-list li').removeClass('active')
                    $(that.elem).find('.nav-container').removeAttr('style')
                    if (!that.opts.flag) {
                        that.opts.whenUnFixed();
                        that.opts.flag = !that.opts.flag;
                    }
                }
            }

        });

    };

    //更新opt
    Module.prototype.updateOpt = function(newOpts, updatePart){
        var opts = this.opts;
        // 更新左邊或右邊(submitBtn)
        if (newOpts.anchors && (updatePart == 'left' || updatePart == 'right')) {
            if (updatePart == 'left') {
                var leftAnchors = newOpts.anchors,
                    rightAnchors = this.opts.haveSubmitBtn?opts.anchors.pop():[];

                newOpts.anchors = leftAnchors.concat(rightAnchors);
                this.opts = $.extend({},opts, newOpts);
            } else if (updatePart == 'right' && newOpts.anchors.length <= 1) {
                (this.opts.haveSubmitBtn == true) && opts.anchors.pop();
                newOpts.anchors = opts.anchors.concat(newOpts.anchors);
                this.opts = $.extend({},opts, newOpts);
            } else {
                console.log("unsupported options!")
            }

        } else if (typeof updatePart == 'undefined') {
            var newOption = $.extend({},opts,newOpts); 
            this.opts = newOption;
        } else {
            console.log("'updatePart' should be left or right");
        }
        this.createEle();
        this.bindClick();
        $(window).trigger('scroll');
    }

    $.fn[ModuleName] = function(options, options2, options3) {
        var args = Array.prototype.slice.call(arguments, 0);
        var options1 = args[0],
            options2 = args.slice(1).length<=0?undefined:args.slice(1, args.length);
        return this.each(function() {
            var $this = $(this);
            var module = $this.data(ModuleName);
            var opts = null;
            if (!!module) {
                if (typeof options === 'string' && typeof options2 === 'undefined') {
                    module[options]();
                } else if (typeof options === 'string' && typeof options2 !== 'undefined') {
                    module[options1].apply(module, options2);
                } else {
                    console.log('unsupported options!');
                    throw 'unsupported options!';
                }
            } else {
                opts = $.extend({}, Module.DEFAULTS, (typeof options1 === 'object' && options1));
                module = new Module(this, opts);
                module.init();
                module.createEle();
                module.bindClick();
                module.scroll();
                $this.data(ModuleName, module);
            }
        })
    }

})(jQuery)


// WEBPACK FOOTER //
// ./magaele/nvb_gptb/module.js